<template>
  <oie-my-pages-template
    v-if="currentMachine"
    :title="currentMachine.name"
    class="machine-details"
    :with-go-back="true">
    <oie-accordion-tabs ref="tabs">
      <oie-accordion-tab name="machine-information" :display-name="tStatic('machineInfo')">
        <oie-edit-wrapper>
          <template #title>
            <span class="body-faint">{{ getNodeHierarchyNames(currentMachine) }}</span>
          </template>
          <template #preview-content>
            <oie-machine-information :machine="currentMachine"></oie-machine-information>
          </template>
          <template #edit-content="{ toggle }">
            <oie-add-edit-machine-form
              :with-delete="true"
              @cancel="toggle"
              @save="handleSave($event, toggle)"
              @delete="handleDelete"></oie-add-edit-machine-form>
          </template>
        </oie-edit-wrapper>
      </oie-accordion-tab>
      <oie-accordion-tab name="machine-order-history" :display-name="tStatic('machineOrderHistory')">
        <oie-my-machines-order-history :id="{machineId: currentMachine.machineId}"></oie-my-machines-order-history>
      </oie-accordion-tab>

      <oie-accordion-tab name="machine-invoice-history" lazy :display-name="tStatic('machineInvoiceHistory')">
        <oie-my-machines-invoice-history :id="{machineId: currentMachine.machineId}"></oie-my-machines-invoice-history>
      </oie-accordion-tab>

      <oie-accordion-tab name="machine-connected-shoppinglists" :display-name="tStatic('machineConnectedShoppingLists')">
        <oie-my-machines-connected-shoppinglists :id="{machineId: currentMachine.machineId}"></oie-my-machines-connected-shoppinglists>
      </oie-accordion-tab>
    </oie-accordion-tabs>
  </oie-my-pages-template>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import myPages from '@/mixins/my-pages'
import tabs from '@/mixins/tabs'
import { getNodeHierarchyNames } from '@/core/my-machines-service'

export default {
  mixins: [myPages, tabs],
  provide() {
    return {
      context: { machineId: this.currentMachine.machineId, machineOwnerId: this.currentMachine.machineOwnerId }
    }
  },
  computed: {
    ...mapGetters('myMachines', ['currentMachine', 'vehicleIdDictionary', 'machineOwnerDictionary', 'metaDataMachineFields'])
  },
  mounted() {
    this.rememberTab(`machine-${this.currentMachine.machineId}-details-tab`)
  },
  methods: {
    ...mapActions('myMachines', ['setCurrentMachine', 'deleteMachine', 'updateMachinesForOwner', 'removeMachineForOwner']),
    handleSave($event, toggle) {
      this.setCurrentMachine($event)
      this.updateMachinesForOwner($event)
      toggle()
    },
    handleDelete() {
      this.publish('modal.show.generic', {
        header: `${this.tStatic('deleteMachineOrOwnerModalHeader')}: ${this.currentMachine.name}`,
        text: this.tStatic('deleteMachineOrOwnerModalText'),
        buttons: [ {
          text: this.tStatic('genericDelete'),
          usePrimaryButton: true,
          handler: async () => {
            await this.deleteMachine(this.currentMachine)
            this.removeMachineForOwner(this.currentMachine)
            this.goBack()
            this.publish('modal.hide.generic')
          }
        }]
      })
    },
    getNodeHierarchyNames: getNodeHierarchyNames
  }
}
</script>

<style lang="scss">
</style>
